import React from "react";
import { Link } from "react-router-dom";

import { IoMdMail } from "react-icons/io";
import {
  FaChevronRight,
  FaMapMarkerAlt,
  FaFacebookSquare,
  FaTwitterSquare,
  FaLinkedin,
} from "react-icons/fa";

import { GiWorld } from "react-icons/gi";
import { useSelector } from "react-redux";
import Logo from "../../assets/new-images/header-logo.png";

const tempGeneralSettings = {
  contactNumber: "(612) 427-8888",
  contactEmail: "info@cabtify.com",
  website: "www.cabtify.com",
  address: "8900 Penn Ave S Suite:309,Bloomington, MN 55431",
};

function Footer() {
  const settings = useSelector((state) => state.settings);
  const { data } = settings;
  const { generalSettings } = data;
  console.log(settings, generalSettings);

  const handleLinkClick = (type, value) => {
    switch (type) {
      case "phone":
        window.location.href = `tel:${value}`;
        break;
      case "email":
        window.location.href = `mailto:${value}`;
        break;
      case "website":
        // For external links, use a regular anchor tag
        window.open("https://" + value.replace("www.", ""), "_blank");
        break;
      case "address":
        // You can modify this to open a map application or use a map API for better integration
        window.location.href = `https://www.google.com/maps?q=${encodeURIComponent(
          value
        )}`;
        break;
      default:
        break;
    }
  };

  return (
    <div className="footer-section">
      <div className="container">
        <div className="row">
          <div className="col-md-4">
            <div className="footer-logo mb-4">
              <Link href="/">
                <img src={Logo} alt="Footer logo" id="footerlogo" />
              </Link>
            </div>
            <div className="down-app">
              <div className="d-flex">
                <a
                  href="https://play.google.com/store/apps/details?id=com.iconictek.cabtify.request.ride&pcampaignid=web_share"
                  target="_blank"
                  rel="noreferrer"
                  className="pe-3 pb-3"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="100"
                    height="40"
                    viewBox="0 0 215 78"
                    fill="none"
                  >
                    <mask
                      id="mask0_6_359"
                      style={{ maskType: "luminance" }}
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="215"
                      height="78"
                    >
                      <path
                        d="M214.138 0H0V77.6667H214.138V0Z"
                        fill="white"
                      ></path>
                    </mask>
                    <g mask="url(#mask0_6_359)">
                      <path
                        d="M201.933 0H12.4267C5.56361 0 0 5.56361 0 12.4267V65.24C0 72.1031 5.56361 77.6667 12.4267 77.6667H201.933C208.797 77.6667 214.36 72.1031 214.36 65.24V12.4267C214.36 5.56361 208.797 0 201.933 0Z"
                        fill="#323232"
                      ></path>
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M72.1031 23.6776C72.1031 24.9793 71.7179 26.0154 70.9459 26.7889C70.0682 27.7085 68.9265 28.1683 67.5223 28.1683C66.1771 28.1683 65.0323 27.7023 64.0926 26.7687C63.1497 25.8367 62.6806 24.6795 62.6806 23.3002C62.6806 21.9192 63.1497 20.7636 64.0926 19.83C65.0323 18.898 66.1771 18.432 67.5223 18.432C68.1887 18.432 68.8287 18.5625 69.4345 18.8219C70.0418 19.0829 70.528 19.4292 70.8931 19.8626L70.0729 20.6828C69.4562 19.9465 68.6066 19.5768 67.5223 19.5768C66.5406 19.5768 65.6925 19.9217 64.9764 20.6113C64.2603 21.3026 63.9031 22.1973 63.9031 23.3002C63.9031 24.4015 64.2603 25.2977 64.9764 25.9874C65.6925 26.6787 66.5406 27.0219 67.5223 27.0219C68.5631 27.0219 69.4298 26.6755 70.1257 25.9812C70.5762 25.5292 70.8371 24.9016 70.9055 24.0939H67.5223V22.974H72.0379C72.0814 23.2178 72.1031 23.4508 72.1031 23.6776Z"
                        fill="white"
                      ></path>
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M79.2626 19.7848H75.0189V22.7393H78.8447V23.8592H75.0189V26.8137H79.2626V27.96H73.8213V18.64H79.2626V19.7848Z"
                        fill="white"
                      ></path>
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M84.3131 27.96H83.1155V19.7848H80.5121V18.64H86.9165V19.7848H84.3131V27.96Z"
                        fill="white"
                      ></path>
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M91.5498 27.96H92.7474V18.64H91.5498V27.96Z"
                        fill="white"
                      ></path>
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M98.0596 27.96H96.862V19.7848H94.2586V18.64H100.663V19.7848H98.0596V27.96Z"
                        fill="white"
                      ></path>
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M106.837 25.975C107.527 26.674 108.37 27.0219 109.369 27.0219C110.366 27.0219 111.211 26.674 111.901 25.975C112.591 25.276 112.937 24.3844 112.937 23.3002C112.937 22.2159 112.591 21.3228 111.901 20.6253C111.211 19.9263 110.366 19.5768 109.369 19.5768C108.37 19.5768 107.527 19.9263 106.837 20.6253C106.149 21.3228 105.803 22.2159 105.803 23.3002C105.803 24.3844 106.149 25.276 106.837 25.975ZM112.786 26.7548C111.87 27.6976 110.731 28.1683 109.369 28.1683C108.007 28.1683 106.868 27.6976 105.953 26.7548C105.037 25.8134 104.58 24.6624 104.58 23.3002C104.58 21.9379 105.037 20.7853 105.953 19.844C106.868 18.9027 108.007 18.432 109.369 18.432C110.724 18.432 111.859 18.9042 112.78 19.8502C113.7 20.7962 114.16 21.9456 114.16 23.3002C114.16 24.6624 113.702 25.8134 112.786 26.7548Z"
                        fill="white"
                      ></path>
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M115.84 27.96V18.64H117.297L121.827 25.8894H121.879L121.827 24.0938V18.64H123.026V27.96H121.776L117.038 20.358H116.985L117.038 22.1552V27.96H115.84Z"
                        fill="white"
                      ></path>
                      <path
                        d="M168.701 54.4718H171.686V34.4922H168.701V54.4718ZM195.602 41.689L192.178 50.3515H192.076L188.523 41.689H185.306L190.635 53.7958L187.596 60.5307H190.711L198.923 41.689H195.602ZM178.663 52.2023C177.687 52.2023 176.321 51.7132 176.321 50.5049C176.321 48.9643 178.021 48.3713 179.489 48.3713C180.8 48.3713 181.419 48.6558 182.216 49.0394C181.984 50.8917 180.389 52.2023 178.663 52.2023ZM179.025 41.2511C176.863 41.2511 174.624 42.2037 173.696 44.3101L176.347 45.4161C176.914 44.3101 177.969 43.9505 179.076 43.9505C180.62 43.9505 182.19 44.8759 182.216 46.5205V46.7267C181.676 46.4182 180.516 45.9563 179.102 45.9563C176.243 45.9563 173.334 47.5242 173.334 50.4538C173.334 53.1276 175.678 54.8506 178.303 54.8506C180.31 54.8506 181.419 53.9508 182.113 52.896H182.216V54.4382H185.101V46.7778C185.101 43.2313 182.447 41.2511 179.025 41.2511ZM160.567 44.1215H156.319V37.2731H160.567C162.799 37.2731 164.068 39.1175 164.068 40.6965C164.068 42.2452 162.799 44.1215 160.567 44.1215ZM160.49 34.4905H153.334V54.4718H156.319V46.9025H160.49C163.8 46.9025 167.054 44.5083 167.054 40.6965C167.054 36.8848 163.8 34.4905 160.49 34.4905ZM121.466 52.2055C119.403 52.2055 117.676 50.481 117.676 48.1124C117.676 45.7166 119.403 43.9665 121.466 43.9665C123.502 43.9665 125.101 45.7166 125.101 48.1124C125.101 50.481 123.502 52.2055 121.466 52.2055ZM124.895 42.8078H124.791C124.121 42.0103 122.831 41.2879 121.208 41.2879C117.804 41.2879 114.683 44.275 114.683 48.1124C114.683 51.9226 117.804 54.8841 121.208 54.8841C122.831 54.8841 124.121 54.1634 124.791 53.3387H124.895V54.3167C124.895 56.9187 123.502 58.3076 121.26 58.3076C119.428 58.3076 118.293 56.9954 117.829 55.8878L115.225 56.9698C115.973 58.7711 117.957 60.9863 121.26 60.9863C124.766 60.9863 127.732 58.9261 127.732 53.9044V41.7002H124.895V42.8078ZM129.795 54.4718H132.786V34.4922H129.795V54.4718ZM137.195 47.8806C137.118 45.2531 139.232 43.9154 140.753 43.9154C141.94 43.9154 142.946 44.5083 143.282 45.357L137.195 47.8806ZM146.478 45.6143C145.91 44.096 144.183 41.2879 140.651 41.2879C137.144 41.2879 134.229 44.0433 134.229 48.0869C134.229 51.8971 137.118 54.8841 140.985 54.8841C144.105 54.8841 145.91 52.9791 146.659 51.8714L144.338 50.326C143.563 51.4591 142.507 52.2055 140.985 52.2055C139.465 52.2055 138.381 51.5103 137.686 50.1454L146.787 46.3863L146.478 45.6143ZM73.9586 43.3751V46.2585H80.8684C80.6635 47.8806 80.1209 49.0649 79.2965 49.8881C78.2899 50.8933 76.7165 52.0009 73.9586 52.0009C69.7026 52.0009 66.3766 48.5759 66.3766 44.3278C66.3766 40.0796 69.7026 36.653 73.9586 36.653C76.2539 36.653 77.9297 37.5544 79.167 38.7147L81.2045 36.6802C79.4758 35.0323 77.1822 33.7698 73.9586 33.7698C68.1293 33.7698 63.2299 38.5086 63.2299 44.3278C63.2299 50.1453 68.1293 54.8841 73.9586 54.8841C77.1038 54.8841 79.4758 53.8533 81.3325 51.9226C83.2405 50.0175 83.8343 47.3388 83.8343 45.1765C83.8343 44.5083 83.783 43.8899 83.6791 43.3751H73.9586ZM91.69 52.2055C89.6284 52.2055 87.8485 50.5065 87.8485 48.0869C87.8485 45.6399 89.6284 43.9665 91.69 43.9665C93.7532 43.9665 95.533 45.6399 95.533 48.0869C95.533 50.5065 93.7532 52.2055 91.69 52.2055ZM91.69 41.2879C87.9254 41.2879 84.857 44.1472 84.857 48.0869C84.857 52.0009 87.9254 54.8841 91.69 54.8841C95.4562 54.8841 98.5245 52.0009 98.5245 48.0869C98.5245 44.1472 95.4562 41.2879 91.69 41.2879ZM106.598 52.2055C104.535 52.2055 102.755 50.5065 102.755 48.0869C102.755 45.6399 104.535 43.9665 106.598 43.9665C108.661 43.9665 110.439 45.6399 110.439 48.0869C110.439 50.5065 108.661 52.2055 106.598 52.2055ZM106.598 41.2879C102.833 41.2879 99.7649 44.1472 99.7649 48.0869C99.7649 52.0009 102.833 54.8841 106.598 54.8841C110.363 54.8841 113.431 52.0009 113.431 48.0869C113.431 44.1472 110.363 41.2879 106.598 41.2879Z"
                        fill="white"
                      ></path>
                      <path
                        d="M41.9355 32.7016L18.2447 19.1851C17.2367 18.6114 16.0883 18.8336 15.334 19.5191L35.1938 39.42L41.9355 32.7016Z"
                        fill="url(#paint0_linear_6_359)"
                      ></path>
                      <path
                        d="M15.3341 19.5199C14.8445 19.9642 14.5191 20.6002 14.5191 21.3545V57.6261C14.5191 58.3116 14.7903 58.8998 15.2065 59.3376L35.194 39.4192L15.3341 19.5199Z"
                        fill="url(#paint1_linear_6_359)"
                      ></path>
                      <path
                        d="M15.2061 59.3377C15.9525 60.1208 17.1806 60.4053 18.2475 59.7948L41.9718 46.2112L35.1934 39.4193L15.2061 59.3377Z"
                        fill="url(#paint2_linear_6_359)"
                      ></path>
                      <path
                        d="M49.9739 37.2883L41.9339 32.7019L35.1938 39.4186L41.9705 46.2105L49.977 41.6256C51.6532 40.6667 51.65 38.2456 49.9739 37.2883Z"
                        fill="url(#paint3_linear_6_359)"
                      ></path>
                    </g>
                    <defs>
                      <linearGradient
                        id="paint0_linear_6_359"
                        x1="30.9359"
                        y1="29.1386"
                        x2="19.9167"
                        y2="22.4639"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stopColor="#00F076"></stop>
                        <stop offset="1" stopColor="#0BE070"></stop>
                      </linearGradient>
                      <linearGradient
                        id="paint1_linear_6_359"
                        x1="23.4712"
                        y1="35.68"
                        x2="26.8803"
                        y2="31.9919"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stopColor="#00E2FF"></stop>
                        <stop offset="1" stopColor="#01C4F7"></stop>
                      </linearGradient>
                      <linearGradient
                        id="paint2_linear_6_359"
                        x1="19.2754"
                        y1="53.4667"
                        x2="27.9502"
                        y2="49.53"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stopColor="#EB214E"></stop>
                        <stop offset="1" stopColor="#FF3A44"></stop>
                      </linearGradient>
                      <linearGradient
                        id="paint3_linear_6_359"
                        x1="43.2132"
                        y1="39.4561"
                        x2="35.1938"
                        y2="39.4561"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stopColor="#FFD902"></stop>
                        <stop offset="1" stopColor="#FFBD00"></stop>
                      </linearGradient>
                    </defs>
                  </svg>
                </a>
                <a
                  href="https://apps.apple.com/pk/app/cabtify-request-a-ride/id6503247684"
                  target="_blank"
                  rel="noreferrer"
                  className="pe-3 pb-3"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="100"
                    height="40"
                    viewBox="0 0 215 78"
                    fill="none"
                  >
                    <path
                      d="M206.124 0H9.73801C4.83582 0 0.861816 3.974 0.861816 8.87619V68.7905C0.861816 73.6927 4.83582 77.6667 9.73801 77.6667H206.124C211.026 77.6667 215 73.6927 215 68.7905V8.87619C215 3.974 211.026 0 206.124 0Z"
                      fill="#323232"
                    ></path>
                    <path
                      d="M46.3443 38.0917C46.383 35.1144 47.9602 32.3643 50.5231 30.8049C48.8989 28.5091 46.2761 27.1058 43.4458 27.0182C40.4681 26.7088 37.5813 28.7816 36.0639 28.7816C34.5172 28.7816 32.181 27.0489 29.6652 27.1002C26.3551 27.206 23.3441 29.0234 21.7336 31.8875C18.3042 37.7638 20.8623 46.4001 24.1474 51.1502C25.7911 53.4761 27.712 56.0743 30.2254 55.9821C32.685 55.8811 33.6037 54.4298 36.5725 54.4298C39.514 54.4298 40.3757 55.9821 42.9403 55.9235C45.5795 55.8811 47.2424 53.5873 48.8283 51.2393C50.0093 49.582 50.918 47.7503 51.5208 45.8121C48.3862 44.4998 46.348 41.4601 46.3443 38.0917Z"
                      fill="white"
                    ></path>
                    <path
                      d="M41.5005 23.8941C42.9396 22.1844 43.6485 19.9868 43.4769 17.7682C41.2784 17.9966 39.2475 19.0366 37.789 20.6807C36.3489 22.3028 35.6192 24.425 35.7609 26.5798C37.989 26.6026 40.1044 25.6126 41.5005 23.8941Z"
                      fill="white"
                    ></path>
                    <path
                      d="M77.4351 50.0937H69.0416L67.026 55.9842H63.4708L71.421 34.1909H75.1146L83.0648 55.9842H79.4491L77.4351 50.0937ZM69.9109 47.3755H76.5641L73.2843 37.8157H73.1926L69.9109 47.3755Z"
                      fill="white"
                    ></path>
                    <path
                      d="M100.235 48.0406C100.235 52.9781 97.5645 56.1504 93.5349 56.1504C91.452 56.2583 89.49 55.1786 88.4836 53.3705H88.4074V61.2405H85.112V40.0952H88.3017V42.7379H88.3624C89.4136 40.9413 91.3777 39.8621 93.4743 39.929C97.5488 39.929 100.235 43.1167 100.235 48.0406ZM96.8476 48.0406C96.8476 44.8237 95.1679 42.7088 92.605 42.7088C90.0871 42.7088 88.3935 44.8682 88.3935 48.0406C88.3935 51.242 90.0871 53.386 92.605 53.386C95.1679 53.386 96.8476 51.2866 96.8476 48.0406Z"
                      fill="white"
                    ></path>
                    <path
                      d="M117.904 48.0406C117.904 52.9781 115.235 56.1504 111.205 56.1504C109.122 56.2583 107.16 55.1786 106.154 53.3705H106.077V61.2405H102.782V40.0952H105.972V42.7379H106.032C107.084 40.9413 109.048 39.8621 111.144 39.929C115.219 39.929 117.904 43.1167 117.904 48.0406ZM114.518 48.0406C114.518 44.8237 112.838 42.7088 110.275 42.7088C107.757 42.7088 106.064 44.8682 106.064 48.0406C106.064 51.242 107.757 53.386 110.275 53.386C112.838 53.386 114.518 51.2866 114.518 48.0406Z"
                      fill="white"
                    ></path>
                    <path
                      d="M129.583 49.9118C129.827 52.0731 131.949 53.492 134.848 53.492C137.625 53.492 139.623 52.073 139.623 50.1243C139.623 48.4327 138.418 47.4199 135.565 46.7257L132.711 46.0454C128.667 45.0787 126.791 43.2073 126.791 40.1703C126.791 36.4101 130.101 33.8274 134.802 33.8274C139.456 33.8274 142.646 36.4101 142.752 40.1703H139.426C139.227 37.9954 137.41 36.6826 134.756 36.6826C132.101 36.6826 130.284 38.011 130.284 39.9441C130.284 41.4849 131.445 42.3915 134.283 43.0855L136.709 43.6751C141.227 44.7325 143.104 46.5287 143.104 49.7163C143.104 53.7936 139.823 56.3472 134.604 56.3472C129.72 56.3472 126.423 53.8535 126.21 49.9117L129.583 49.9118Z"
                      fill="white"
                    ></path>
                    <path
                      d="M150.215 36.3348V40.095H153.268V42.6778H150.215V51.4372C150.215 52.798 150.826 53.4322 152.169 53.4322C152.532 53.4258 152.893 53.4007 153.253 53.3567V55.924C152.649 56.0355 152.036 56.0861 151.422 56.0748C148.172 56.0748 146.904 54.8666 146.904 51.7851V42.6778H144.57V40.095H146.904V36.3348H150.215Z"
                      fill="white"
                    ></path>
                    <path
                      d="M155.037 48.0407C155.037 43.0414 158.011 39.9 162.651 39.9C167.306 39.9 170.267 43.0413 170.267 48.0407C170.267 53.0537 167.321 56.1814 162.651 56.1814C157.983 56.1814 155.037 53.0537 155.037 48.0407ZM166.909 48.0407C166.909 44.6113 165.321 42.5873 162.651 42.5873C159.981 42.5873 158.394 44.6267 158.394 48.0407C158.394 51.4838 159.981 53.4924 162.651 53.4924C165.321 53.4924 166.909 51.4838 166.909 48.0407Z"
                      fill="white"
                    ></path>
                    <path
                      d="M172.984 40.095H176.128V42.7995H176.203C176.641 41.0585 178.254 39.8604 180.065 39.9288C180.445 39.9275 180.823 39.9683 181.194 40.0505V43.1011C180.715 42.9562 180.215 42.8896 179.714 42.904C178.745 42.8652 177.808 43.2473 177.147 43.9501C176.487 44.6528 176.17 45.6061 176.28 46.5597V55.984H172.984V40.095Z"
                      fill="white"
                    ></path>
                    <path
                      d="M196.388 51.3172C195.945 54.2015 193.107 56.181 189.475 56.181C184.805 56.181 181.906 53.0841 181.906 48.1157C181.906 43.1319 184.821 39.8995 189.337 39.8995C193.778 39.8995 196.572 42.9193 196.572 47.737V48.8544H185.233V49.0514C185.127 50.2343 185.54 51.4053 186.365 52.2663C187.192 53.1274 188.353 53.5957 189.552 53.552C191.151 53.7002 192.659 52.7914 193.259 51.3171L196.388 51.3172ZM185.248 46.575H193.274C193.334 45.5121 192.944 44.4727 192.196 43.7071C191.448 42.9416 190.412 42.5195 189.337 42.5423C188.253 42.5359 187.211 42.9583 186.443 43.7155C185.675 44.4728 185.246 45.5022 185.248 46.575Z"
                      fill="white"
                    ></path>
                    <path
                      d="M69.4946 18.3841C70.8939 18.2836 72.2642 18.8165 73.2287 19.836C74.1932 20.8556 74.6501 22.2544 74.4737 23.6474C74.4737 27.0314 72.6467 28.9766 69.4946 28.9766H65.6725V18.3841H69.4946ZM67.3161 27.4787H69.3111C70.311 27.5385 71.2846 27.1441 71.9615 26.4051C72.6385 25.666 72.9468 24.661 72.8008 23.669C72.9362 22.6811 72.6235 21.6844 71.9481 20.9513C71.2729 20.2183 70.3057 19.8257 69.3111 19.881H67.3161V27.4787Z"
                      fill="white"
                    ></path>
                    <path
                      d="M76.3305 24.9766C76.1936 23.5438 76.88 22.1572 78.1018 21.3982C79.3235 20.6392 80.8694 20.6392 82.0912 21.3982C83.3129 22.1572 83.9992 23.5438 83.8623 24.9766C84.0019 26.411 83.3162 27.8003 82.0933 28.5609C80.8705 29.3215 79.3225 29.3215 78.0996 28.5609C76.8768 27.8003 76.1911 26.411 76.3305 24.9766ZM82.2413 24.9766C82.2413 23.2438 81.4638 22.2305 80.099 22.2305C78.7292 22.2305 77.9585 23.2438 77.9585 24.9767C77.9585 26.7233 78.7292 27.7287 80.099 27.7287C81.4638 27.7287 82.2413 26.7163 82.2413 24.9766Z"
                      fill="white"
                    ></path>
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M93.8743 28.9767H92.2394L90.589 23.0892H90.4643L88.8208 28.9767H87.2015L85.0003 20.9829H86.5988L88.0293 27.0826H88.1471L89.7889 20.9829H91.3008L92.9425 27.0826H93.0672L94.4908 20.9829H96.0667L93.8743 28.9767Z"
                      fill="white"
                    ></path>
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M97.9181 20.9832H99.4351V22.253H99.5529C99.9625 21.3181 100.919 20.7462 101.936 20.8288C102.723 20.7696 103.494 21.0719 104.032 21.6503C104.57 22.2287 104.815 23.0205 104.7 23.802V28.9768H103.124V24.1982C103.124 22.9136 102.566 22.2748 101.401 22.2748C100.867 22.2498 100.349 22.4596 99.9823 22.8489C99.6159 23.2383 99.4374 23.7685 99.494 24.3004V28.9769H97.9181V20.9832Z"
                      fill="white"
                    ></path>
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M107.21 17.8624H108.786V28.9768H107.21V17.8624Z"
                      fill="white"
                    ></path>
                    <path
                      d="M110.977 24.9763C110.84 23.5435 111.527 22.1568 112.748 21.3978C113.97 20.6389 115.517 20.6389 116.738 21.3978C117.96 22.1568 118.647 23.5435 118.51 24.9763C118.649 26.4109 117.963 27.8001 116.74 28.5607C115.518 29.3212 113.969 29.3212 112.746 28.5607C111.524 27.8001 110.838 26.4109 110.977 24.9763ZM116.888 24.9763C116.888 23.2436 116.11 22.2303 114.746 22.2303C113.375 22.2303 112.605 23.2436 112.605 24.9765C112.605 26.7231 113.375 27.7285 114.746 27.7285C116.11 27.7285 116.888 26.7161 116.888 24.9763Z"
                      fill="white"
                    ></path>
                    <path
                      d="M120.169 26.716C120.169 25.277 121.24 24.4475 123.139 24.3296L125.303 24.2048V23.5149C125.303 22.6705 124.745 22.1938 123.667 22.1938C122.787 22.1938 122.178 22.5171 122.003 23.0823H120.477C120.638 21.7092 121.929 20.8286 123.741 20.8286C125.742 20.8286 126.872 21.8263 126.872 23.5149V28.9766H125.355V27.8532H125.229C124.715 28.6736 123.798 29.1532 122.831 29.1083C122.153 29.1789 121.477 28.9592 120.97 28.5033C120.463 28.0475 120.172 27.3982 120.169 26.716ZM125.303 26.0329V25.3646L123.352 25.4894C122.253 25.5631 121.753 25.9375 121.753 26.6423C121.753 27.3617 122.377 27.7804 123.235 27.7804C123.743 27.8318 124.249 27.6749 124.638 27.3455C125.029 27.0161 125.268 26.5424 125.303 26.0329Z"
                      fill="white"
                    ></path>
                    <path
                      d="M128.943 24.9764C128.943 22.4505 130.24 20.8504 132.257 20.8504C133.276 20.8033 134.23 21.3499 134.706 22.2528H134.823V17.8624H136.4V28.9768H134.89V27.7138H134.765C134.253 28.6093 133.287 29.1465 132.257 29.1085C130.226 29.1086 128.943 27.5084 128.943 24.9764ZM130.571 24.9764C130.571 26.6719 131.368 27.6921 132.704 27.6921C134.032 27.6921 134.853 26.6572 134.853 24.9834C134.853 23.3173 134.024 22.2676 132.704 22.2676C131.377 22.2676 130.571 23.2948 130.571 24.9764Z"
                      fill="white"
                    ></path>
                    <path
                      d="M142.921 24.9766C142.783 23.5438 143.47 22.1572 144.692 21.3982C145.913 20.6392 147.459 20.6392 148.681 21.3982C149.903 22.1572 150.589 23.5438 150.452 24.9766C150.592 26.411 149.906 27.8003 148.684 28.5609C147.46 29.3215 145.912 29.3215 144.689 28.5609C143.467 27.8003 142.781 26.411 142.921 24.9766ZM148.831 24.9766C148.831 23.2438 148.053 22.2305 146.689 22.2305C145.319 22.2305 144.549 23.2438 144.549 24.9767C144.549 26.7233 145.32 27.7287 146.689 27.7287C148.053 27.7287 148.831 26.7163 148.831 24.9766Z"
                      fill="white"
                    ></path>
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M152.566 20.9832H154.084V22.253H154.201C154.611 21.3181 155.568 20.7462 156.585 20.8288C157.371 20.7696 158.142 21.0719 158.681 21.6503C159.219 22.2287 159.464 23.0205 159.348 23.802V28.9768H157.773V24.1982C157.773 22.9136 157.215 22.2748 156.049 22.2748C155.515 22.2498 154.997 22.4596 154.631 22.8489C154.265 23.2383 154.086 23.7685 154.143 24.3004V28.9769H152.566V20.9832Z"
                      fill="white"
                    ></path>
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M168.254 18.993V21.0196H169.984V22.3485H168.254V26.4589C168.254 27.2963 168.599 27.6629 169.383 27.6629C169.584 27.6622 169.785 27.6501 169.984 27.6265V28.9406C169.7 28.9913 169.414 29.0183 169.127 29.0211C167.374 29.0211 166.676 28.404 166.676 26.8628V22.3484H165.409V21.0196H166.676V18.993H168.254Z"
                      fill="white"
                    ></path>
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M172.136 17.8624H173.698V22.2676H173.822C174.252 21.3245 175.226 20.7517 176.258 20.8356C177.04 20.793 177.801 21.1019 178.332 21.6782C178.865 22.2545 179.112 23.0381 179.008 23.8157V28.9768H177.43V24.2049C177.43 22.9281 176.836 22.2814 175.723 22.2814C175.175 22.2364 174.634 22.436 174.246 22.8267C173.859 23.2174 173.664 23.7595 173.712 24.3081V28.9768H172.136V17.8624Z"
                      fill="white"
                    ></path>
                    <path
                      d="M188.197 26.8184C187.756 28.3262 186.298 29.3005 184.738 29.1311C183.673 29.1592 182.65 28.7174 181.938 27.9228C181.228 27.1283 180.903 26.0613 181.049 25.005C180.907 23.9458 181.231 22.8772 181.937 22.0759C182.644 21.2746 183.663 20.8195 184.73 20.8288C186.952 20.8288 188.293 22.3484 188.293 24.8585V25.409H182.654V25.4974C182.604 26.0906 182.806 26.6773 183.211 27.1133C183.616 27.5492 184.186 27.794 184.781 27.7875C185.551 27.8801 186.302 27.4972 186.68 26.8183L188.197 26.8184ZM182.654 24.2422H186.687C186.727 23.6998 186.537 23.1654 186.162 22.7711C185.788 22.3768 185.265 22.159 184.721 22.1714C184.171 22.1645 183.64 22.3804 183.251 22.7703C182.863 23.1602 182.646 23.691 182.654 24.2422Z"
                      fill="white"
                    ></path>
                  </svg>
                </a>
              </div>
            </div>
          </div>
          <div className="col-md-2">
            <div className="footer-menu">
              <h4>Company</h4>
            </div>
            <div className="footer-menu">
              <ul>
                <li>
                  <FaChevronRight />
                  <Link to="/">Home</Link>
                </li>
                <li>
                  <FaChevronRight />
                  <Link to="/about-us/">About Us</Link>
                </li>
                <li>
                  <FaChevronRight />
                  <Link to="/services/">Services</Link>
                </li>
                <li>
                  <FaChevronRight />
                  <Link to="/contact-us/">Contact Us</Link>
                </li>
              </ul>
            </div>
          </div>
          {/* <div className="col-md-2">
            <div className="footer-menu">
              <h4>Products</h4>
            </div>
            <div className="footer-menu">
              <ul>
                <li>
                  <FaChevronRight />
                  <Link href="#">Riders</Link>
                </li>
                <li>
                  <FaChevronRight />
                  <Link href="#">Drivers</Link>
                </li>
                <li>
                  <FaChevronRight />
                  <Link href="#">Help Center</Link>
                </li>
              </ul>
            </div>
          </div> */}
          <div className="col-md-4">
            <div className="footer-menu">
              <h4>Contact Us</h4>
            </div>
            {/* <div className="footer-menu">
              <ul>
                <li>
                  <i className="fa fa-envelope" id="foot-icon"></i>
                  <Link href="#">info@cabtify.com</Link>
                </li>
                <li>
                  <i className="fa fa fa-globe" id="foot-icon"></i>
                  <Link href="#">www.cabtify.com</Link>
                </li>
                <li>
                  <i className="fa fa fa-map-marker" id="foot-icon"></i>
                  <Link href="#">
                    8900 Penn Ave S #309,
                    <br /> Bloomington, MN 55431
                  </Link>
                </li>
              </ul>
            </div> */}

            <div className="footer-menu">
              <ul>
                {/* <li
                  onClick={() =>
                    handleLinkClick(
                      "phone",
                      generalSettings
                        ? generalSettings.contactNumber
                        : tempGeneralSettings.contactNumber
                    )
                  }
                >
                  <BsFillTelephoneFill />{" "}
                  <Link href="#">
                    {generalSettings
                      ? generalSettings.contactNumber
                      : tempGeneralSettings.contactNumber}
                  </Link>
                </li> */}
                <li
                  onClick={() =>
                    handleLinkClick(
                      "email",
                      generalSettings
                        ? generalSettings.contactEmail
                        : tempGeneralSettings.contactEmail
                    )
                  }
                >
                  <IoMdMail />
                  <Link href="#">
                    {" "}
                    {generalSettings
                      ? generalSettings.contactEmail
                      : tempGeneralSettings.contactEmail}
                  </Link>
                </li>
                <li
                  onClick={() =>
                    handleLinkClick(
                      "website",
                      generalSettings
                        ? generalSettings.website
                        : tempGeneralSettings.website
                    )
                  }
                >
                  <GiWorld />
                  <Link href="#">
                    {generalSettings
                      ? generalSettings.website
                      : tempGeneralSettings.website}
                  </Link>
                </li>
                <li
                  onClick={() =>
                    handleLinkClick(
                      "address",
                      generalSettings
                        ? generalSettings.address
                        : tempGeneralSettings.address
                    )
                  }
                >
                  <FaMapMarkerAlt />{" "}
                  <Link href="#">
                    {" "}
                    {generalSettings
                      ? generalSettings.address
                      : tempGeneralSettings.address}
                  </Link>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-md-12">
            <div className="footer-border"></div>
          </div>
          <div className="row">
            <div className="footer-botm">
              <div className="fbotm-text">
                <p>© {new Date().getFullYear()} Cabtify Technology Inc.</p>
              </div>
              <div className="fbotm-text">
                <ul>
                  <li>
                    <Link to="/privacy-policy">Terms of Service</Link>
                  </li>
                  <li>
                    <Link to="/privacy-policy">Privacy Policy</Link>
                  </li>
                </ul>
              </div>
              <div className="footer-soc">
                <ul>
                  <li>
                    <Link href="#">
                      <FaFacebookSquare />
                    </Link>
                  </li>
                  <li>
                    <Link href="#">
                      <FaTwitterSquare />
                    </Link>
                  </li>
                  <li>
                    <Link href="#">
                      <FaLinkedin />
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;
